import 'css-chunksrc/client/pages/zonesPage/projectsPage/loader/project/styles.scss';export default {
  "project": "_project_cn4cw_1"
};